import React, { useEffect, useState } from "react";
import { useSite } from "../lib/SiteContext";

function useCountUp(target, duration = 1400) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!target) {
      setVal(0);
      return;
    }
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);
  return val;
}

function StatCard({ value, label, accent, testid }) {
  const display = useCountUp(value);
  const isEmpty = !value || value <= 0;
  return (
    <div
      data-testid={testid}
      className="relative rounded-3xl bg-white border border-dashed border-[#D6D3D1] p-8 md:p-10 hover:-translate-y-1 transition-transform duration-300"
    >
      <div
        className="font-display text-5xl md:text-6xl font-extrabold tracking-tight"
        style={{ color: isEmpty ? "#D6D3D1" : accent }}
      >
        {isEmpty ? "—" : (
          <>
            {display.toLocaleString()}
            <span className="text-2xl align-top ml-1">+</span>
          </>
        )}
      </div>
      <div className="mt-3 text-sm font-semibold uppercase tracking-[0.14em] text-[#57534E]">
        {label}
      </div>
      {isEmpty && (
        <div className="mt-2 text-xs text-[#A8A29E] italic">Add real number</div>
      )}
    </div>
  );
}

export default function Impact() {
  const { config } = useSite();
  const stats = config.stats || {};

  return (
    <section
      id="impact"
      data-testid="impact-section"
      className="bg-[#EAE5DF] py-20 md:py-28 relative overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.18em] text-[#D85C41]">
            Impact So Far
          </span>
          <h2 className="mt-3 font-display text-4xl md:text-5xl font-bold leading-[1.05]">
            Small loads. Big difference.
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#57534E]">
            Real numbers, coming soon. Every load washed will be a small win
            for a child in Hamilton — and we'll share the count as it grows.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          <StatCard value={stats.loads_washed} label="Loads Washed" accent="#D85C41" testid="stat-loads" />
          <StatCard value={stats.children_supported} label="Children Supported" accent="#1C1917" testid="stat-children" />
          <StatCard value={stats.families_helped} label="Families Helped" accent="#9EA992" testid="stat-families" />
          <StatCard value={stats.volunteer_hours} label="Volunteer Hours" accent="#EBB04D" testid="stat-volunteers" />
        </div>
      </div>
    </section>
  );
}
